module.exports = __webpack_public_path__ + "static/media/logo_name_large.04e5b705.png";